/* RESPONSIBLE TEAM: team-ai-agent */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
import type Transition from '@ember/routing/-private/transition';
import { hash } from 'rsvp';
import type IntlService from 'embercom/services/intl';
import type IntercomConfirmService from 'embercom/services/intercom-confirm-service';
import { tracked } from '@glimmer/tracking';

const OPERATOR_SETTINGS_PERMISSION = 'can_create_and_edit_bots';

export default class FinAIAgentSettingsCustomAnswersRoute extends IntercomRoute {
  @service declare appService: any;
  @service declare permissionsService: any;
  @service declare store: Store;
  @service declare intl: IntlService;
  @service declare modalService: any;
  @service declare intercomEventService: any;
  @service declare intercomConfirmService: IntercomConfirmService;

  @tracked showAiAgentImportSettingsModal = false;

  analytics = {
    section: 'ai-chatbot',
    place: 'settings.custom-answers',
  };

  get titleToken(): string {
    return this.intl.t('ai-agent.settings.custom-answer-settings-title');
  }

  beforeModel(transition: Transition) {
    this.permissionsService.ensurePermissionWhenTransitioning(
      OPERATOR_SETTINGS_PERMISSION,
      transition,
    );
  }

  async model() {
    let appId = this.appService.app.id;

    return hash({
      aiAgentSettings: this.store.findRecord('ai-agent/settings', appId),
      conversationImports: this.store.findAll('conversation-import'),
      refreshRoute: this.refresh,
    });
  }

  get app() {
    return this.appService.app;
  }
}
